import { c as _c } from "react/compiler-runtime";
interface EmailIconProps {
  color?: string;
  size?: number;
}
const EmailIcon = t0 => {
  const $ = _c(7);
  const {
    color: t1,
    size: t2
  } = t0;
  const color = t1 === undefined ? "currentColor" : t1;
  const size = t2 === undefined ? 24 : t2;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  if ($[2] !== color) {
    t5 = <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill={color} />;
    $[2] = color;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <svg className="dynamic-size" style={t4} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">{t5}</svg>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default EmailIcon;